import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";
import { LanderCookie } from "../commons/Constants";
import { getCookie } from "../commons/HelperFunctions";
import { ExperimentIds } from "../commons/constants/experiment";
import { useIsMobile } from "../commons/useIsMobile";
import { FeedType } from "../types/LanderConfig";
import { isControlCohort } from "./helper";

export const MOBILEAPP_CONTROL_TAG = "PW_MOBILEAPP_CONTROL";
export const MOBILEAPP_TREATMENT_TAG = "PW_MOBILEAPP_TREATMENT";

export function useMobileAppAdExperiment() {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const inExperiment = key === ExperimentIds.mobileAppAd;
  const inTreatmentCohort = inExperiment && cohort && !isControlCohort(cohort);
  const isYahooFeed = landerConfig.lander?.feedID === FeedType.YAHOO;
  const isUS = getCookie(LanderCookie.COUNTRY) === "US";
  const isMobile = useIsMobile();
  const hasBanner =
    !!landerConfig.lander?.banner?.show && !!landerConfig.lander?.banner?.link;
  const isEligible =
    inExperiment && isYahooFeed && isUS && isMobile && hasBanner;

  const showMobileAppAd = isEligible && !!inTreatmentCohort;

  useEffect(() => {
    if (!isEligible) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_BANNER_AND_CHANNEL_BY_TREATMENT,
      payload: { inTreatmentCohort },
    });

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_YAHOO_TYPE_TAG,
      payload: {
        typeTag: inTreatmentCohort
          ? MOBILEAPP_TREATMENT_TAG
          : MOBILEAPP_CONTROL_TAG,
      },
    });
  }, [isEligible, inTreatmentCohort, landerConfigDispatch]);

  return { showMobileAppAd };
}
